import { render, staticRenderFns } from "./ContentRelated.vue?vue&type=template&id=16dbbc3a&scoped=true"
import script from "./ContentRelated.vue?vue&type=script&lang=js"
export * from "./ContentRelated.vue?vue&type=script&lang=js"
import style0 from "./ContentRelated.vue?vue&type=style&index=0&id=16dbbc3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dbbc3a",
  null
  
)

export default component.exports